<template>
  <transition name="import-fade">
    <div v-if="visible" class="import-modal-overlay" @click.self="tutup">
      <div class="import-modal" role="dialog" aria-modal="true">
        <!-- ============================= KEPALA MODAL ============================= -->
        <div class="import-modal-head">
          <div>
            <h5>Import Data Kontak</h5>
            <p>Unggah berkas kontak sesuai format yang sudah ditentukan.</p>
          </div>
          <button
            type="button"
            class="import-close"
            title="Tutup"
            :disabled="uploading"
            @click="tutup"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>

        <!-- ============================= ISI MODAL ============================= -->
        <div class="import-modal-body">
          <div class="import-top-action">
            <div>
              <strong>Contoh Format File</strong>
              <p>Gunakan contoh format agar kontak Anda dapat diproses.</p>
            </div>
            <button
              type="button"
              class="btn import-btn import-btn-outline"
              :disabled="uploading || !urlTemplate"
              @click="unduhTemplate"
            >
              <i class="fa fa-download"></i>
              <span>Unduh Contoh Format File</span>
            </button>
          </div>

          <div v-if="errorMessage" class="import-alert">
            <i class="fa fa-exclamation-circle"></i>
            <span>{{ errorMessage }}</span>
          </div>

          <!-- Area unggah -->
          <div
            class="import-dropzone"
            :class="{ 'is-dragover': dragging, 'is-disabled': uploading }"
            @click="bukaPemilihBerkas"
            @dragover.prevent="dragging = true"
            @dragleave.prevent="dragging = false"
            @drop.prevent="jatuhkanBerkas"
          >
            <input
              ref="fileInput"
              type="file"
              accept=".xlsx"
              class="import-file-input"
              :disabled="uploading"
              @change="ubahBerkas"
            />
            <div class="import-dropzone-icon">
              <i class="fa fa-cloud-upload"></i>
            </div>
            <h6>Pilih atau tarik file kontak ke sini</h6>
            <p>Format yang didukung: <strong>.xlsx</strong> &middot; maksimal 10 MB</p>
          </div>

          <!-- Pratinjau berkas -->
          <div v-if="berkas" class="import-file-card">
            <div class="import-file-icon">
              <i class="fa fa-file-excel-o"></i>
            </div>
            <div class="import-file-info">
              <strong>{{ berkas.name }}</strong>
              <span>{{ formatUkuran(berkas.size) }}</span>
            </div>
            <button
              type="button"
              class="import-file-remove"
              title="Hapus berkas"
              :disabled="uploading"
              @click="hapusBerkas"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>

          <!-- Status proses -->
          <div v-if="uploading" class="import-loading-box">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Memproses file kontak...</span>
          </div>

          <!-- Target grup -->
          <div class="form-group">
            <label>Masukkan ke Grup</label>
            <a-select
              v-model="selectedGroupIds"
              mode="multiple"
              show-search
              allow-clear
              option-filter-prop="children"
              placeholder="Pilih Grup (opsional)"
              style="width: 100%"
              :disabled="uploading"
              :not-found-content="grupNotFoundContent"
              @search="onGroupSearch"
              @change="onGroupChange"
            >
              <a-select-option
                v-for="grup in groups"
                :key="grup.id"
                :value="grup.id"
              >
                {{ grup.name }}
              </a-select-option>
            </a-select>
            <div v-if="grupBaruTerdeteksi" class="import-inline-create">
              <button
                type="button"
                class="import-inline-create-btn"
                :disabled="creatingGroup"
                @click.prevent="buatGrupBaru"
              >
                <i :class="creatingGroup ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"></i>
                <span v-if="creatingGroup">Membuat grup...</span>
                <span v-else>Buat grup baru: "{{ groupSearch.trim() }}"</span>
              </button>
            </div>
            <div v-if="groupCreateError" class="import-inline-error">
              {{ groupCreateError }}
            </div>
            <small class="import-help">
              Kontak yang diimport akan dimasukkan ke grup yang dipilih.
            </small>
          </div>

          <!-- Tagging massal -->
          <div class="form-group">
            <label>Tagging Massal</label>
            <a-select
              v-model="selectedTagIds"
              mode="multiple"
              show-search
              allow-clear
              option-filter-prop="children"
              placeholder="Pilih Tagging (opsional)"
              style="width: 100%"
              :disabled="uploading"
              :not-found-content="tagNotFoundContent"
              @search="onTagSearch"
              @change="onTagChange"
            >
              <a-select-option
                v-for="tag in tags"
                :key="tag.id"
                :value="tag.id"
              >
                {{ tag.name }}
              </a-select-option>
            </a-select>
            <div v-if="tagBaruTerdeteksi" class="import-inline-create">
              <button
                type="button"
                class="import-inline-create-btn"
                :disabled="creatingTag"
                @click.prevent="buatTagBaru"
              >
                <i :class="creatingTag ? 'fa fa-spinner fa-spin' : 'fa fa-plus'"></i>
                <span v-if="creatingTag">Membuat tagging...</span>
                <span v-else>Buat tagging baru: "{{ tagSearch.trim() }}"</span>
              </button>
            </div>
            <div v-if="tagCreateError" class="import-inline-error">
              {{ tagCreateError }}
            </div>
            <small class="import-help">
              Tagging diterapkan ke kontak baru pada grup tujuan. Penyesuaian
              per kontak dapat dilakukan dari daftar Kontak.
            </small>
          </div>

          <!-- Panduan format -->
          <div class="import-info">
            <div class="import-info-title">
              <i class="fa fa-info-circle"></i>
              <strong>Ketentuan Berkas</strong>
            </div>
            <ul>
              <li>Format berkas <strong>.xlsx</strong>, maksimal 10 MB.</li>
              <li>Maksimal 5.000 kontak per proses import.</li>
              <li>Jumlah dan isi kontak akan diperiksa secara otomatis.</li>
              <li>Nama sheet wajib <strong>Sheet1</strong>.</li>
              <li>
                Nomor WhatsApp menggunakan kode negara tanpa spasi.
                Contoh: <strong>6281234567890</strong>.
              </li>
              <li>
                Tanggal lahir opsional dengan format <strong>YYYY-MM-DD</strong>.
              </li>
            </ul>
          </div>
        </div>

        <!-- ============================= AKSI MODAL ============================= -->
        <div class="import-modal-foot">
          <button
            type="button"
            class="btn import-btn import-btn-outline"
            :disabled="uploading"
            @click="tutup"
          >
            Batal
          </button>
          <button
            type="button"
            class="btn import-btn import-btn-primary"
            :disabled="uploading || !berkas"
            @click="importSekarang"
          >
            <i v-if="uploading" class="fa fa-spinner fa-spin"></i>
            <span v-if="uploading && taggingMassal">Menerapkan tagging...</span>
            <span v-else-if="uploading">Memproses...</span>
            <span v-else>Import Sekarang</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";
import { APICore } from "@/utils/servicesApi";
import { getXAuthToken, getXAuthAgent } from "@/utils/auth";
import {
  ambilKontakGrup,
  terapkanTagKeKontakBaru
} from "@/utils/contactTagging";

export default {
  name: "ContactImportModalV2",

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      urlTemplate: process.env.VUE_APP_IC_URL,
      urlImport:
        process.env.VUE_APP_BASE_API + APICore() + "/contact/import-contact",
      groups: [],
      tags: [],
      selectedGroupIds: [],
      selectedTagIds: [],
      groupSearch: "",
      tagSearch: "",
      creatingGroup: false,
      creatingTag: false,
      groupCreateError: "",
      tagCreateError: "",
      taggingMassal: false,
      berkas: null,
      dragging: false,
      uploading: false,
      errorMessage: ""
    };
  },

  computed: {
    grupBaruTerdeteksi() {
      const query = String(this.groupSearch || "").trim().toLowerCase();
      if (!query) {
        return false;
      }
      return !this.groups.some(grup => {
        return String(grup.name || "").trim().toLowerCase() === query;
      });
    },
    tagBaruTerdeteksi() {
      const query = String(this.tagSearch || "").trim().toLowerCase();
      if (!query) {
        return false;
      }
      return !this.tags.some(tag => {
        return String(tag.name || "").trim().toLowerCase() === query;
      });
    },
    grupNotFoundContent() {
      const h = this.$createElement;
      const query = String(this.groupSearch || "").trim();

      if (!query) {
        return h(
          "div",
          { class: "import-inline-create is-dropdown" },
          "Tidak ada grup ditemukan."
        );
      }

      return h(
        "div",
        { class: "import-inline-create is-dropdown" },
        [
          h(
            "button",
            {
              class: "import-inline-create-btn",
              attrs: {
                type: "button",
                disabled: this.creatingGroup
              },
              on: {
                mousedown: event => {
                  event.preventDefault();
                  event.stopPropagation();
                },
                click: event => {
                  event.preventDefault();
                  event.stopPropagation();
                  this.buatGrupBaru();
                }
              }
            },
            [
              h("i", {
                class: this.creatingGroup
                  ? "fa fa-spinner fa-spin"
                  : "fa fa-plus"
              }),
              h(
                "span",
                this.creatingGroup
                  ? "Membuat grup..."
                  : 'Buat grup baru: "' + query + '"'
              )
            ]
          )
        ]
      );
    },
    tagNotFoundContent() {
      const h = this.$createElement;
      const query = String(this.tagSearch || "").trim();

      if (!query) {
        return h(
          "div",
          { class: "import-inline-create is-dropdown" },
          "Tidak ada tagging ditemukan."
        );
      }

      return h(
        "div",
        { class: "import-inline-create is-dropdown" },
        [
          h(
            "button",
            {
              class: "import-inline-create-btn",
              attrs: {
                type: "button",
                disabled: this.creatingTag
              },
              on: {
                mousedown: event => {
                  event.preventDefault();
                  event.stopPropagation();
                },
                click: event => {
                  event.preventDefault();
                  event.stopPropagation();
                  this.buatTagBaru();
                }
              }
            },
            [
              h("i", {
                class: this.creatingTag
                  ? "fa fa-spinner fa-spin"
                  : "fa fa-plus"
              }),
              h(
                "span",
                this.creatingTag
                  ? "Membuat tagging..."
                  : 'Buat tagging baru: "' + query + '"'
              )
            ]
          )
        ]
      );
    }
  },

  watch: {
    visible(value) {
      if (value) {
        this.resetForm();
        this.muatGrup();
        this.muatTag();
      } else {
        this.resetForm();
      }
    }
  },

  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },

  methods: {
    /* ============================= DATA GRUP ============================= */

    async muatGrup() {
      try {
        const response = await this.$store.dispatch("contact/getGroupList", {
          name: "",
          page: 0,
          perPage: 1000
        });

        this.groups = (response && response.data) || [];
      } catch (error) {
        console.log(error);
        this.groups = [];
      }
    },

    async muatTag() {
      try {
        const response = await this.$store.dispatch("contact/getTagList", {
          name: "",
          page: 0,
          perPage: 1000
        });
        const payload = (response && response.data) || {};
        const daftar = Array.isArray(payload.data) ? payload.data : [];

        this.tags = daftar.map(tag => {
          return {
            id: tag.id,
            name: this.namaTagBersih(tag.name)
          };
        });
      } catch (error) {
        console.log(error);
        this.tags = [];
      }
    },

    onGroupSearch(query) {
      this.groupSearch = query || "";
      this.groupCreateError = "";
    },

    onTagSearch(query) {
      this.tagSearch = query || "";
      this.tagCreateError = "";
    },

    onGroupChange() {
      this.groupSearch = "";
      this.groupCreateError = "";
    },

    onTagChange() {
      this.tagSearch = "";
      this.tagCreateError = "";
    },

    tambahPilihanGrup(idGrup) {
      const sudahAda = this.selectedGroupIds.some(id => {
        return String(id) === String(idGrup);
      });

      if (!sudahAda) {
        this.selectedGroupIds.push(idGrup);
      }
    },

    tambahPilihanTag(idTag) {
      const sudahAda = this.selectedTagIds.some(id => {
        return String(id) === String(idTag);
      });

      if (!sudahAda) {
        this.selectedTagIds.push(idTag);
      }
    },

    normalisasiGrupBaru(response, namaCadangan) {
      const payload =
        response && response.data !== undefined ? response.data : response;
      const grup = Array.isArray(payload) ? payload[0] : payload;

      if (!grup) {
        return null;
      }

      return {
        ...grup,
        id: grup.id !== undefined ? grup.id : grup.Id,
        name: grup.name || grup.group_name || namaCadangan
      };
    },

    normalisasiTagBaru(response, namaCadangan) {
      const payload =
        response && response.data !== undefined ? response.data : response;
      const tag = Array.isArray(payload) ? payload[0] : payload;

      if (!tag) {
        return null;
      }

      return {
        ...tag,
        id: tag.id !== undefined ? tag.id : tag.Id,
        name: this.namaTagBersih(tag.name || namaCadangan)
      };
    },

    async buatGrupBaru() {
      const nama = String(this.groupSearch || "").trim();

      if (!nama || this.creatingGroup) {
        return;
      }

      const grupAda = this.groups.find(grup => {
        return String(grup.name || "").trim().toLowerCase() === nama.toLowerCase();
      });

      if (grupAda) {
        this.tambahPilihanGrup(grupAda.id);
        this.groupSearch = "";
        return;
      }

      this.creatingGroup = true;
      this.groupCreateError = "";

      try {
        const response = await this.$store.dispatch("contact/createGroup", {
          id: "",
          name: nama,
          description: ""
        });
        const grup = this.normalisasiGrupBaru(response, nama);

        if (!grup || grup.id === undefined || grup.id === null || grup.id === "") {
          throw new Error("ID grup baru tidak ditemukan pada respons server.");
        }

        const sudahAda = this.groups.some(item => {
          return String(item.id) === String(grup.id);
        });

        if (!sudahAda) {
          this.groups.push(grup);
        }

        this.tambahPilihanGrup(grup.id);
        this.groupSearch = "";
      } catch (error) {
        console.log(error);
        this.groupCreateError =
          "Gagal membuat grup baru. Silakan periksa nama grup lalu coba lagi.";
      } finally {
        this.creatingGroup = false;
      }
    },

    async buatTagBaru() {
      const nama = String(this.tagSearch || "").trim();

      if (!nama || this.creatingTag) {
        return;
      }

      const tagAda = this.tags.find(tag => {
        return String(tag.name || "").trim().toLowerCase() === nama.toLowerCase();
      });

      if (tagAda) {
        this.tambahPilihanTag(tagAda.id);
        this.tagSearch = "";
        return;
      }

      this.creatingTag = true;
      this.tagCreateError = "";

      try {
        const response = await this.$store.dispatch("crm/createTag", {
          id: "",
          name: nama,
          description: ""
        });
        const tag = this.normalisasiTagBaru(response, nama);

        if (!tag || tag.id === undefined || tag.id === null || tag.id === "") {
          throw new Error("ID tagging baru tidak ditemukan pada respons server.");
        }

        const sudahAda = this.tags.some(item => {
          return String(item.id) === String(tag.id);
        });

        if (!sudahAda) {
          this.tags.push(tag);
        }

        this.tambahPilihanTag(tag.id);
        this.tagSearch = "";
      } catch (error) {
        console.log(error);
        this.tagCreateError =
          "Gagal membuat tagging baru. Silakan periksa nama tagging lalu coba lagi.";
      } finally {
        this.creatingTag = false;
      }
    },

    namaTagBersih(nama) {
      return String(nama || "").replace(/\s~\s\d+$/, "");
    },

    /* ============================= BERKAS ============================= */

    resetForm() {
      this.selectedGroupIds = [];
      this.selectedTagIds = [];
      this.groupSearch = "";
      this.tagSearch = "";
      this.creatingGroup = false;
      this.creatingTag = false;
      this.groupCreateError = "";
      this.tagCreateError = "";
      this.taggingMassal = false;
      this.berkas = null;
      this.dragging = false;
      this.uploading = false;
      this.errorMessage = "";
    },

    bukaPemilihBerkas() {
      if (this.uploading) {
        return;
      }
      this.$refs.fileInput.click();
    },

    ubahBerkas(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";

      if (file) {
        this.pilihBerkas(file);
      }
    },

    jatuhkanBerkas(event) {
      this.dragging = false;

      if (this.uploading) {
        return;
      }

      const file = event.dataTransfer.files && event.dataTransfer.files[0];

      if (file) {
        this.pilihBerkas(file);
      }
    },

    pilihBerkas(file) {
      this.errorMessage = "";

      if (!this.validasiBerkas(file)) {
        this.berkas = null;
        return;
      }

      this.berkas = file;
    },

    validasiBerkas(file) {
      const nama = String(file.name || "").toLowerCase();

      if (nama.slice(-5) !== ".xlsx") {
        this.errorMessage =
          "Format berkas tidak didukung. Silakan gunakan berkas .xlsx.";
        return false;
      }

      if (file.size > 10 * 1024 * 1024) {
        this.errorMessage =
          "Ukuran berkas melebihi batas 10 MB. Silakan perkecil berkas terlebih dahulu.";
        return false;
      }

      return true;
    },

    hapusBerkas() {
      if (this.uploading) {
        return;
      }
      this.berkas = null;
    },

    formatUkuran(bytes) {
      if (!bytes) {
        return "0 KB";
      }

      if (bytes < 1024 * 1024) {
        return Math.ceil(bytes / 1024) + " KB";
      }

      return (bytes / (1024 * 1024)).toFixed(1) + " MB";
    },

    unduhTemplate() {
      if (!this.urlTemplate) {
        this.errorMessage = "Tautan template belum tersedia.";
        return;
      }

      window.open(this.urlTemplate, "_blank");
    },

    /* ============================= PROSES IMPORT ============================= */

    headerPermintaan() {
      const headers = {};
      const token = getXAuthToken();
      const agent = getXAuthAgent();

      if (token) {
        headers["X-Auth-Token"] = "Bearer " + token;
      }

      if (agent) {
        headers["X-Auth-Agent"] = "Bearer " + agent;
      }

      return headers;
    },

    async importSekarang() {
      if (this.uploading) {
        return;
      }

      if (!this.berkas) {
        this.errorMessage = "Silakan pilih berkas import terlebih dahulu.";
        return;
      }

      if (!this.validasiBerkas(this.berkas)) {
        return;
      }

      if (this.selectedTagIds.length && !this.selectedGroupIds.length) {
        this.errorMessage =
          "Pilih grup tujuan terlebih dahulu agar tagging massal dapat diterapkan.";
        return;
      }

      this.uploading = true;
      this.errorMessage = "";

      let baselineKontakIds = [];

      if (this.selectedTagIds.length && this.selectedGroupIds.length) {
        try {
          const kontakAwal = await ambilKontakGrup(
            this.$store,
            this.selectedGroupIds
          );
          baselineKontakIds = kontakAwal.map(kontak => kontak.id);
        } catch (error) {
          console.log(error);
          this.uploading = false;
          this.errorMessage =
            "Gagal memeriksa data grup tujuan. Silakan coba lagi.";
          return;
        }
      }

      const formData = new FormData();
      formData.append("file", this.berkas);

      const listId = this.selectedGroupIds.join(",");
      if (listId) {
        formData.append("list_id", listId);
      }

      try {
        const response = await axios.post(this.urlImport, formData, {
          headers: this.headerPermintaan(),
          timeout: 50000
        });

        const body = response.data || {};

        if (Number(body.status) !== 200) {
          throw body;
        }

        let peringatan = "";

        if (this.selectedTagIds.length && this.selectedGroupIds.length) {
          this.taggingMassal = true;

          try {
            const hasil = await terapkanTagKeKontakBaru(this.$store, {
              groupIds: this.selectedGroupIds,
              tagIds: this.selectedTagIds,
              baselineIds: baselineKontakIds
            });

            if (!hasil.ok) {
              peringatan = hasil.message;
            }
          } catch (tagError) {
            console.log(tagError);
            peringatan =
              "Kontak berhasil diimpor, tetapi tagging massal belum dapat diterapkan. Silakan atur tagging dari daftar Kontak.";
          }

          this.taggingMassal = false;
        }

        this.uploading = false;
        this.taggingMassal = false;

        this.$emit("success", {
          message:
            "Selamat! File kontak berhasil diunggah dan sedang ditambahkan ke daftar Anda.",
          warning: peringatan
        });
      } catch (error) {
        console.log(error);
        this.uploading = false;
        this.taggingMassal = false;
        this.errorMessage = this.pesanImportGagal(error);
      }
    },

    /* ============================= PESAN ============================= */

    ambilPesanError(error) {
      if (!error) {
        return "";
      }

      let pesan = "";

      if (typeof error === "string") {
        pesan = error;
      } else if (error.msg) {
        pesan = String(error.msg);
      } else if (
        error.response &&
        error.response.data &&
        error.response.data.msg
      ) {
        pesan = String(error.response.data.msg);
      } else if (error.message) {
        pesan = String(error.message);
      }

      return pesan
        .replace(/<br\s*\/?>/gi, " ")
        .replace(/<[^>]*>/g, "")
        .trim();
    },

    pesanImportGagal(error) {
      const pesanDasar =
        "File tidak dapat diproses. Pastikan Anda menggunakan format file yang sesuai dengan contoh.";
      const detail = this.ambilPesanError(error);
      const teks = detail.toLowerCase();

      if (teks.indexOf("only allowed file") !== -1) {
        return "Format file belum sesuai. Silakan gunakan file .xlsx seperti pada contoh.";
      }

      if (teks.indexOf("max upload") !== -1) {
        return "Ukuran file terlalu besar. Pastikan ukurannya tidak melebihi 10 MB.";
      }

      if (teks.indexOf("sheet1 is not found") !== -1) {
        return "Data kontak tidak ditemukan. Pastikan nama sheet pada file adalah Sheet1.";
      }

      if (
        !detail ||
        teks.indexOf("network error") !== -1 ||
        teks.indexOf("timeout") !== -1 ||
        teks.indexOf("failed to fetch") !== -1 ||
        teks.indexOf("dial tcp") !== -1 ||
        teks.indexOf("runtime error") !== -1 ||
        teks.indexOf("panic") !== -1 ||
        teks.indexOf("sql") !== -1
      ) {
        return pesanDasar;
      }

      return pesanDasar;
    },

    /* ============================= UTILITAS ============================= */

    tutup() {
      if (this.uploading) {
        return;
      }

      this.$emit("close");
    },

    handleKeydown(event) {
      if (event.key === "Escape" && this.visible) {
        this.tutup();
      }
    }
  }
};
</script>

<style scoped>
.import-modal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;
  background: rgba(15, 23, 42, 0.5);
}

.import-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 680px;
  max-height: calc(100vh - 32px);
  overflow: hidden;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.26);
}

.import-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  border-bottom: 1px solid #eef2f7;
}

.import-modal-head h5 {
  margin: 0;
  color: #101828;
  font-size: 17px;
  font-weight: 700;
}

.import-modal-head p {
  margin: 4px 0 0;
  color: #667085;
  font-size: 12px;
}

.import-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
}

.import-close:hover:not(:disabled) {
  color: #b42318;
  background: #fef3f2;
  border-color: #fecdca;
}

.import-close:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.import-modal-body {
  padding: 18px 20px;
  overflow-y: auto;
}

.import-modal-foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 14px 20px;
  background: #fbfcfe;
  border-top: 1px solid #eef2f7;
}

.import-top-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 14px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 12px;
}

.import-top-action strong {
  color: #344054;
  font-size: 12px;
}

.import-top-action p {
  margin: 3px 0 0;
  color: #667085;
  font-size: 11px;
}

.import-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 40px;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.import-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.22);
}

.import-btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.import-btn-primary {
  color: #ffffff;
  background-color: #f39c12;
  border-color: #f39c12;
  font-weight: 700;
  box-shadow: 0 7px 16px rgba(243, 156, 18, 0.24);
}

.import-btn-primary:hover:not(:disabled),
.import-btn-primary:focus:not(:disabled) {
  color: #ffffff;
  background-color: #e08e0b;
  border-color: #e08e0b;
}

.import-btn-outline {
  color: #555555;
  background-color: #ffffff;
  border-color: #d1d5db;
}

.import-btn-outline:hover:not(:disabled),
.import-btn-outline:focus:not(:disabled) {
  color: #444444;
  background-color: #f9fafb;
  border-color: #b9bec7;
}

.import-alert {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  margin-bottom: 14px;
  color: #912018;
  background: #fef3f2;
  border: 1px solid #fecdca;
  border-radius: 10px;
  font-size: 12px;
  line-height: 1.5;
}

.import-alert i {
  margin-top: 2px;
  color: #d92d20;
}

.import-dropzone {
  padding: 26px 16px;
  text-align: center;
  background: #fffdf8;
  border: 2px dashed #f2d29a;
  border-radius: 14px;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease;
}

.import-dropzone:hover,
.import-dropzone.is-dragover {
  background: #fff7e8;
  border-color: #f39c12;
}

.import-dropzone.is-disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.import-dropzone-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin: 0 auto 10px;
  color: #f39c12;
  background: #fff7e8;
  border-radius: 14px;
  font-size: 20px;
}

.import-dropzone h6 {
  margin: 0 0 4px;
  color: #344054;
  font-size: 13px;
  font-weight: 700;
}

.import-dropzone p {
  margin: 0;
  color: #667085;
  font-size: 11px;
}

.import-file-input {
  display: none;
}

.import-file-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-top: 12px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.import-file-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  color: #067647;
  background: #ecfdf3;
  border-radius: 9px;
  font-size: 16px;
}

.import-file-info {
  min-width: 0;
}

.import-file-info strong {
  display: block;
  overflow: hidden;
  color: #344054;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.import-file-info span {
  display: block;
  color: #98a2b3;
  font-size: 10px;
}

.import-file-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  margin-left: auto;
  padding: 0;
  color: #b42318;
  background: #fef3f2;
  border: 1px solid #fecdca;
  border-radius: 8px;
  font-size: 11px;
  cursor: pointer;
}

.import-file-remove:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.import-loading-box {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 12px 14px;
  margin-top: 12px;
  color: #344054;
  background: #fffdf8;
  border: 1px solid #f2d29a;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
}

.import-loading-box i {
  color: #f39c12;
  font-size: 16px;
}

.import-modal .form-group > label {
  margin-bottom: 6px;
  color: #344054;
  font-size: 12px;
  font-weight: 600;
}

.import-help {
  display: block;
  margin-top: 5px;
  color: #98a2b3;
  font-size: 10px;
  line-height: 1.5;
}

.import-inline-create {
  margin-top: 7px;
}

.import-inline-create.is-dropdown {
  padding: 5px 8px 8px;
  margin-top: 0;
  color: #98a2b3;
  font-size: 11px;
  line-height: 1.4;
}

.import-inline-create-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 30px;
  padding: 5px 11px;
  color: #b36b00;
  background: #fffaf1;
  border: 1px dashed #f6c26b;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.3;
  text-align: left;
  transition: background-color 0.18s ease, border-color 0.18s ease;
}

.import-inline-create-btn:hover:not(:disabled) {
  background: #fff3df;
  border-color: #f39c12;
}

.import-inline-create-btn:disabled {
  cursor: wait;
  opacity: 0.65;
}

.import-inline-error {
  margin-top: 5px;
  color: #b42318;
  font-size: 11px;
  line-height: 1.45;
}

.import-info {
  padding: 12px 14px;
  margin-top: 4px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 12px;
}

.import-info-title {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 6px;
  color: #344054;
  font-size: 12px;
}

.import-info-title i {
  color: #f39c12;
}

.import-info ul {
  padding-left: 18px;
  margin: 0;
  color: #667085;
  font-size: 11px;
  line-height: 1.8;
}

.import-fade-enter-active,
.import-fade-leave-active {
  transition: opacity 0.18s ease;
}

.import-fade-enter,
.import-fade-leave-to {
  opacity: 0;
}

@media (max-width: 575px) {
  .import-modal-overlay {
    padding: 10px;
  }

  .import-modal {
    max-height: calc(100vh - 20px);
  }

  .import-modal-head,
  .import-modal-body,
  .import-modal-foot {
    padding-left: 15px;
    padding-right: 15px;
  }

  .import-top-action {
    align-items: flex-start;
    flex-direction: column;
  }

  .import-modal-foot {
    flex-direction: column-reverse;
  }

  .import-modal-foot .import-btn {
    width: 100%;
  }
}
</style>

<style>
/* Penyesuaian komponen Ant Design Select pada modal import. */
.import-modal .ant-select-selection {
  min-height: 40px;
  border: 1px solid #d8e1ee;
  border-radius: 9px;
}

.import-modal .ant-select-selection:hover {
  border-color: #f6c26b;
}

.import-modal .ant-select-selection:focus,
.import-modal .ant-select-selection:active {
  border-color: #f6c26b;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.14);
}

.import-modal .ant-select-selection__choice {
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
}

.import-modal .ant-select-selection__choice__remove {
  color: #b36b00;
}
</style>



// WEBPACK FOOTER //
// src/views/contacts/ContactImportModalV2.vue